// import { fa } from '@fortawesome/free-solid-svg-icons';
import { addMessage } from '../redux/actions/global';
import { END_WAIT, WAIT } from '../redux/types/global';
// import { USER_UNAUTHENTICATED } from '../redux/types/security';
import { mmurApi } from './axios_config';

export function postData(url, data, dispatch, actionType, async) {
  return new Promise((resolve, reject) => {
    if (!async && dispatch) {
      dispatch({
        type: WAIT,
      });
    }

    mmurApi
      .post(url, data)
      .then((response) => {
        if (dispatch) {
          dispatch({
            type: END_WAIT,
          });
        }

        if (actionType && dispatch) {
          if (actionType !== 'auth_user' || response.data) {
            dispatch({
              type: actionType,
              payload: response?.data?.data,
            });
          }
        }
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function postDataWithProgress(url, data, dispatch, actionType, progressCallback) {
  return new Promise((resolve, reject) => {
    const config = {
      onUploadProgress: (event) => {
        const percentCompleted = Math.round((event.loaded * 100) / event.total);
        progressCallback(percentCompleted);
      },
    };

    mmurApi
      .post(url, data, config)
      .then((response) => {
        if (actionType && dispatch) {
          dispatch({
            type: actionType,
            payload: response.data.data,
          });
        }
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getData(url, dispatch, actionType, async) {
  return new Promise((resolve, reject) => {
    if (!async && dispatch) {
      dispatch({
        type: WAIT,
      });
    }
    mmurApi
      .get(url)
      .then((response) => {
        if (dispatch) {
          dispatch({
            type: END_WAIT,
          });
        }

        if (actionType && dispatch) {
          dispatch({
            type: actionType,
            payload: response.data.data,
          });
        }
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getReport(url, fileName, dispatch, setReportRunning) {
  const link = document.createElement('a');
  link.target = '_blank';
  link.download = fileName;
  mmurApi
    .get(url, {
      responseType: 'blob'
    })
    .then((response) => {
      if (response.data.size > 0) {
        link.href = URL.createObjectURL(
          new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        );
        link.click();
      }
    }).catch(() => {
      const message = {
        type: 'error',
        text: 'No Data Found',
      };
      dispatch(addMessage(message));
    }).finally(() => {
      if (setReportRunning) {
        setReportRunning(false);
      }
    });
}

export function putData(url, data, dispatch, actionType, async) {
  return new Promise((resolve, reject) => {
    if (!async && dispatch) {
      dispatch({
        type: WAIT,
      });
    }

    mmurApi
      .put(url, data)
      .then((response) => {
        dispatch({
          type: END_WAIT,
        });

        if (actionType && dispatch) {
          dispatch({
            type: actionType,
            payload: response?.data?.data,
          });
        }
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function patchData(url, data, dispatch, actionType, async) {
  return new Promise((resolve, reject) => {
    if (!async && dispatch) {
      dispatch({
        type: WAIT,
      });
    }

    mmurApi
      .patch(url, data)
      .then((response) => {
        dispatch({
          type: END_WAIT,
        });

        if (actionType && dispatch) {
          dispatch({
            type: actionType,
            payload: response.data.data,
          });
        }
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteData(url, dispatch, actionType, async) {
  return new Promise((resolve, reject) => {
    if (!async && dispatch) {
      dispatch({
        type: WAIT,
      });
    }

    mmurApi
      .delete(url)
      .then((response) => {
        if (dispatch) {
          dispatch({
            type: END_WAIT,
          });
        }

        if (actionType && dispatch) {
          dispatch({
            type: actionType,
            payload: response.data.data,
          });
        }
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
